import React from 'react';
import './ChatTranscript.scss';

const ChatTranscriptSkeleton: React.FC = () => {
  const messagePlaceholders = Array.from({ length: 4 });

  return (
    <div className="chat-transcript chat-transcript--skeleton">
      <div className="chat-transcript_header-section">
        <div className="chat-transcript__skeleton-line chat-transcript__skeleton-title" />
        <div className="chat-transcript__skeleton-line chat-transcript__skeleton-subtitle" />
        <div className="chat-transcript__skeleton-pill-row">
          <div className="chat-transcript__skeleton-pill chat-transcript__skeleton-pill--wide" />
          <div className="chat-transcript__skeleton-pill chat-transcript__skeleton-pill--medium" />
          <div className="chat-transcript__skeleton-pill chat-transcript__skeleton-pill--narrow" />
        </div>
      </div>

      <div className="chat-transcript_body">
        <div className="chat-transcript_scroll">
          <div className="chat-transcript__skeleton-block chat-transcript__skeleton-system" />

          {messagePlaceholders.map((_, idx) => (
            <div className="chat-transcript__skeleton-message" key={idx}>
              <div className="chat-transcript__skeleton-avatar" />
              <div className="chat-transcript__skeleton-message-content">
                <div className="chat-transcript__skeleton-line chat-transcript__skeleton-line--wide" />
                <div className="chat-transcript__skeleton-line chat-transcript__skeleton-line--medium" />
                <div className="chat-transcript__skeleton-line chat-transcript__skeleton-line--short" />
              </div>
            </div>
          ))}

          <div className="chat-transcript__skeleton-accordion">
            <div className="chat-transcript__skeleton-line chat-transcript__skeleton-accordion-title" />
            <div className="chat-transcript__skeleton-line chat-transcript__skeleton-line--wide" />
            <div className="chat-transcript__skeleton-line chat-transcript__skeleton-line--medium" />
            <div className="chat-transcript__skeleton-line chat-transcript__skeleton-line--short" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatTranscriptSkeleton;
